export type FieldError = {
  message: string;
  messageTemplate:
    | 'failed_to_complete_the_operation'
    | 'incorrect_code'
    | 'invalid_format' // NOTE: Generic error to show  if "messageTemplate" is undefined.
    | 'invalid_phone_number'
    | 'integer_number' // NOTE: This template doesn't come from BE. Used on Finance screen for integer values
    | 'invalid_credentials' // NOTE: This template doesn't come from BE. Used for login field errors
    | '{javax.validation.constraints.Pattern.message}'
    | 'postal_code_invalid'; // NOTE: This template doesn't come from BE.
  property: string;
  source?: string;
};

// Extends Error so it can be caught with instanceof; carries the full array of field-level BE errors
class ValidationError extends Error {
  fieldErrors: FieldError[];

  constructor(fieldErrors: FieldError[]) {
    super('ValidationError');
    this.name = 'ValidationError';
    this.fieldErrors = fieldErrors;
  }
}

export default ValidationError;
